var map = {
	"./backgrounds/background.avif": 661,
	"./icons/01.avif": 16,
	"./icons/02.avif": 938,
	"./icons/03.avif": 994,
	"./icons/04.avif": 101,
	"./icons/09.avif": 625,
	"./icons/10.avif": 932,
	"./icons/11.avif": 512,
	"./icons/13.avif": 92,
	"./icons/50.avif": 680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;